<template>
    <section id="about">
        <div class="container">
            <div data-aos="fade-right" data-aos-duration="1000" data-aos-easing="">
                <h2>Jací jsme?</h2>
            </div>
            <f7-row>
                <f7-col width="100" desktop-width="60" tablet-width="100">
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="" data-aos-delay="200">
                        <span class="highlight">INOVATIVNÍ A PRECIZNÍ!</span> Jsme
                        společnost programátorů, softwarových architektů
                        zabývající se
                        především
                        vývojem složitých softwarových řešení systémů a aplikací ... <span class="highlight">NAŠIMI
                            ZÁKAZNÍKY</span> jsou státní
                        instituce (od
                        ministerstev, přes přímo řízené organizace, až po vysoké, vyšší odborné, střední nebo základní
                        školy) i
                        soukromé subjekty (od nadnárodních organizací až po lokální firmy) ... <span
                            class="highlight">SAMI VYVÍJÍME</span> s předními
                        odborníky v oblasti školství, psychologie, knihovnictví, informační vědy i kyberbezpečnosti
                        elektronický
                        publikační systém <strong>„FutureBooks“</strong> pro tvorbu a distribuci interaktivních
                        výukových médií ...</p>
                    <p data-aos="fade-up">Ačkoliv jsme „papírově“ mladí, jako tým <span class="highlight">JSME
                            DOSTATEČNĚ ZKUŠENÍ</span>, abychom mohli
                        být našim
                        partnerům vždy
                        nápomocni s realizací i přípravou složitých řešení na míru ...</p>
                </f7-col>
                <f7-col width="100" desktop-width="40" tablet-width="100" data-aos-duration="1000" data-aos-easing=""
                    data-aos-delay="400" style="position: relative;">
                    <div class="off-text">
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="500"><em>„vždy nasloucháme
                                partnerům (naše řešení tak nekolidují se stávajícími
                                systémy,
                                ale právě naopak
                                jim
                                napomáhají) a vše zpracováváme dle potřeb i zvyklostí“</em></p>
                    </div>
                </f7-col>
            </f7-row>
        </div>
    </section>
</template>

<script>
    export default {};
</script>

<style>
    #about {
        background: #f7f7f8;
        padding: 11% 0;
        min-height: 50vh;
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    }

    p {
        width: 70%;
        text-align: justify;
        font-size: 1.2rem;
    }

    h2 {
        text-transform: uppercase;
        text-align: left;
        margin-bottom: 100px;
        font-size: 2rem;
    }

    .highlight {
        font-weight: bold;
        font-size: 1.5rem;
        text-transform: uppercase;
    }

    @media screen and (max-width: 426px) {
        p {
            width: 100%;
        }
    }
</style>